<template>
	<div class="">
		<div class="config-row">
			<div class="config-field">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						TTL
						<span class="fa fa-circle-info text-muted ms-1" :title="fieldInfo?.graph_ttl?.tooltip"
							data-bs-toggle="tooltip" data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.graph_ttl?.editable" type="button" class="btn btn-sm btn-secondary"
							@click="resetToDefault('graph_ttl')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>

				</div>
				<input type="text" class="form-control" v-model="config.graph_ttl"
					@input="updateConfig"
					:disabled="!fieldInfo?.graph_ttl?.editable"
					:placeholder="fieldInfo?.graph_ttl?.editable ? fieldInfo?.graph_ttl?.placeholder : ''" />
			</div>

			<div class="config-field">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						Cluster Type
						<span class="fa fa-circle-info text-muted ms-1" :title="fieldInfo?.choose_cluster_type?.tooltip"
							data-bs-toggle="tooltip" data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.choose_cluster_type?.editable" type="button"
							class="btn btn-sm btn-secondary" @click="resetToDefault('choose_cluster_type')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<input type="text" class="form-control" v-model="config.choose_cluster_type"
					@input="updateConfig"
					:disabled="!fieldInfo?.choose_cluster_type?.editable"
					:placeholder="fieldInfo?.choose_cluster_type?.editable ? fieldInfo?.choose_cluster_type?.placeholder : ''" />
			</div>

			<div class="config-field">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						Cluster Domain
						<span class="fa fa-circle-info text-muted ms-1"
							:title="fieldInfo?.choose_cluster_domain?.tooltip" data-bs-toggle="tooltip"
							data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.choose_cluster_domain?.editable" type="button"
							class="btn btn-sm btn-secondary" @click="resetToDefault('choose_cluster_domain')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<input type="text" class="form-control" v-model="config.choose_cluster_domain"
					@input="updateConfig"
					:disabled="!fieldInfo?.choose_cluster_domain?.editable"
					:placeholder="fieldInfo?.choose_cluster_domain?.editable ? fieldInfo?.choose_cluster_domain?.placeholder : ''" />
			</div>
		</div>

		<div class="config-row mb-3 pb-1">
			<div class="config-field">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						Weightage Map
						<span class="fa fa-circle-info text-muted ms-1"
							:title="fieldInfo?.create_cluster_weightage_map?.tooltip" data-bs-toggle="tooltip"
							data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.create_cluster_weightage_map?.editable" type="button"
							class="btn btn-sm btn-secondary" @click="resetToDefault('create_cluster_weightage_map')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<div class="card">
					<div class="card-body">
						<div v-if="Object.keys(config.create_cluster_weightage_map).length > 0">
							<div v-for="(valueObj, key, index) in config.create_cluster_weightage_map" :key="index"
								class="mb-2">
								<div class="input-group mb-1">
									<input type="text" class="form-control" :value="key"
										@input="updateMapKey('create_cluster_weightage_map', key, $event.target.value); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_weightage_map?.editable"
										placeholder="Key" />
									<select class="form-select"
										:value="getMapValueType('create_cluster_weightage_map', key)"
										@change="updateMapValueType('create_cluster_weightage_map', key, $event.target.value); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_weightage_map?.editable">
										<option value="int">Number</option>
										<option value="string">String</option>
										<option value="boolean">Boolean</option>
									</select>
									<select v-if="getMapValueType('create_cluster_weightage_map', key) === 'boolean'"
										class="form-control"
										:value="String(getMapValue('create_cluster_weightage_map', key))"
										@change="updateMapValue('create_cluster_weightage_map', key, $event.target.value === 'true'); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_weightage_map?.editable">
										<option value="true">True</option>
										<option value="false">False</option>
									</select>
									<input v-else
										:type="getMapValueType('create_cluster_weightage_map', key) === 'int' ? 'number' : 'text'"
										class="form-control" :value="getMapValue('create_cluster_weightage_map', key)"
										@input="updateMapValue('create_cluster_weightage_map', key, $event.target.value); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_weightage_map?.editable"
										:placeholder="getMapValueType('create_cluster_weightage_map', key) === 'int' ? 'Number' : 'Value'" />
									<button v-if="fieldInfo?.create_cluster_weightage_map?.editable" type="button"
										class="btn btn-sm btn-outline-danger"
										@click="removeMapEntry('create_cluster_weightage_map', key); updateConfig()">
										<i class="fa fa-trash"></i>
									</button>
								</div>
							</div>
						</div>
						<div v-else>
							<p class="text-muted">No data found!</p>

						</div>
						<button v-if="fieldInfo?.create_cluster_weightage_map?.editable" type="button"
							class="btn btn-sm btn-primary mt-2" @click="addMapEntry('create_cluster_weightage_map'); updateConfig()">
							<i class="fa fa-plus"></i> Add Entry
						</button>
					</div>
				</div>
			</div>
			<div class="config-field">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						TTL Maps
						<span class="fa fa-circle-info text-muted ms-1"
							:title="fieldInfo?.create_cluster_ttl_maps?.tooltip" data-bs-toggle="tooltip"
							data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.create_cluster_ttl_maps?.editable" type="button"
							class="btn btn-sm btn-secondary" @click="resetToDefault('create_cluster_ttl_maps')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<div class="card">
					<div class="card-body">
						<div v-if="Object.keys(config.create_cluster_ttl_maps).length > 0">
							<div v-for="(valueObj, key, index) in config.create_cluster_ttl_maps" :key="index"
								class="mb-2">
								<div class="input-group mb-1">
									<input type="text" class="form-control" :value="key"
										@input="updateMapKey('create_cluster_ttl_maps', key, $event.target.value); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_ttl_maps?.editable" placeholder="Key" />
									<select class="form-select" :value="getMapValueType('create_cluster_ttl_maps', key)"
										@change="updateMapValueType('create_cluster_ttl_maps', key, $event.target.value); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_ttl_maps?.editable">
										<option value="int">Number</option>
										<option value="string">String</option>
										<option value="boolean">Boolean</option>
									</select>
									<select v-if="getMapValueType('create_cluster_ttl_maps', key) === 'boolean'"
										class="form-control"
										:value="String(getMapValue('create_cluster_ttl_maps', key))"
										@change="updateMapValue('create_cluster_ttl_maps', key, $event.target.value === 'true'); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_ttl_maps?.editable">
										<option value="true">True</option>
										<option value="false">False</option>
									</select>
									<input v-else
										:type="getMapValueType('create_cluster_ttl_maps', key) === 'int' ? 'number' : 'text'"
										class="form-control" :value="getMapValue('create_cluster_ttl_maps', key)"
										@input="updateMapValue('create_cluster_ttl_maps', key, $event.target.value); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_ttl_maps?.editable"
										:placeholder="getMapValueType('create_cluster_ttl_maps', key) === 'int' ? 'Number' : 'Value'" />
									<button v-if="fieldInfo?.create_cluster_ttl_maps?.editable" type="button"
										class="btn btn-sm btn-outline-danger"
										@click="removeMapEntry('create_cluster_ttl_maps', key); updateConfig()">
										<i class="fa fa-trash"></i>
									</button>
								</div>
							</div>
						</div>
						<div v-else>
							<p class="text-muted">No data found!</p>
						</div>
						<button v-if="fieldInfo?.create_cluster_ttl_maps?.editable" type="button"
							class="btn btn-sm btn-primary mt-2" @click="addMapEntry('create_cluster_ttl_maps'); updateConfig()">
							<i class="fa fa-plus"></i> Add Entry
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="config-row">
			<div class="config-field config-field-full">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						Invalid IDs
						<span class="fa fa-circle-info text-muted ms-1"
							:title="fieldInfo?.create_cluster_invalid_ids?.tooltip" data-bs-toggle="tooltip"
							data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.create_cluster_invalid_ids?.editable" type="button"
							class="btn btn-sm btn-secondary" @click="resetToDefault('create_cluster_invalid_ids')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<div class="card">
					<div class="card-body">
						<div v-if="config.create_cluster_invalid_ids?.length > 0">
							<div v-for="(item, index) in config.create_cluster_invalid_ids" :key="index"
								class="input-group mb-2">
								<input type="text" class="form-control"
									v-model="config.create_cluster_invalid_ids[index]"
									@input="updateConfig"
									:disabled="!fieldInfo?.create_cluster_invalid_ids?.editable"
									placeholder="Invalid ID" />
								<button v-if="fieldInfo?.create_cluster_invalid_ids?.editable" type="button"
									class="btn btn-sm btn-outline-danger"
									@click="removeArrayItem('create_cluster_invalid_ids', index); updateConfig()">
									<i class="fa fa-trash"></i>
								</button>
							</div>
						</div>
						<div v-else>
							<p class="text-muted">No data found!</p>
						</div>
						<button v-if="fieldInfo?.create_cluster_invalid_ids?.editable" type="button"
							class="btn btn-sm btn-primary mt-2" @click="addArrayItem('create_cluster_invalid_ids'); updateConfig()">
							<i class="fa fa-plus"></i> Add ID
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	data() {
		return {
			config: {
				graph_ttl: "",
				create_cluster_weightage_map: {},
				create_cluster_invalid_ids: [],
				create_cluster_ttl_maps: {},
				choose_cluster_type: "",
				choose_cluster_domain: ""
			},
			isLoadingFromParent: false
		};
	},
	props: {
		modelValue: {
			type: Object,
			default: () => ({})
		},
		fieldInfo: {
			type: Object,
			default: () => ({})
		},
		cleanConfigFn: {
			type: Function,
			required: true
		},
	},
	watch: {
		modelValue: {
			handler(newVal, oldVal) {
				// Only load config if it's actually different (not just a reference change)
				// This prevents overwriting local changes when switching tabs
				if (newVal && typeof newVal === 'object' && Object.keys(newVal).length > 0) {
					// Check if the config has actually changed by comparing key values
					if (!oldVal || !this.isConfigEqual(newVal, oldVal)) {
						this.isLoadingFromParent = true;
						this.loadConfig(newVal);
						this.$nextTick(() => {
							this.isLoadingFromParent = false;
						});
					}
				}
			},
			deep: true,
			immediate: false
		},
	},
	beforeMount() {
		if (this.modelValue && typeof this.modelValue === 'object' && Object.keys(this.modelValue).length > 0) {
			this.loadConfig(this.modelValue);
		}
	},
	methods: {
		isConfigEqual(config1, config2) {
			// Deep comparison to check if configs are actually different
			if (!config1 || !config2) return false;
			const keys1 = Object.keys(config1);
			const keys2 = Object.keys(config2);
			if (keys1.length !== keys2.length) return false;
			
			for (let key of keys1) {
				if (JSON.stringify(config1[key]) !== JSON.stringify(config2[key])) {
					return false;
				}
			}
			return true;
		},
		updateConfig() {
			// Emit updated config to parent to maintain state
			// Don't emit if we're currently loading from parent (prevents infinite loop)
			if (!this.isLoadingFromParent) {
				const configObj = this.cleanConfigFn(this.config);
				this.$emit('update:modelValue', configObj);
			}
		},
		loadConfig(value) {
			if (!value || typeof value !== 'object') {
				return;
			}

			// Initialize config with prop values or defaults
			const weightageMap = {};
			if (value.create_cluster_weightage_map && typeof value.create_cluster_weightage_map === 'object') {
				Object.keys(value.create_cluster_weightage_map).forEach(key => {
					const val = value.create_cluster_weightage_map[key];
					// Convert old format (just value) to new format (object with type and value)
					if (val && typeof val === 'object' && val.value !== undefined) {
						weightageMap[key] = { ...val };
					} else {
						// Auto-detect type - only detect int if value is actually a number type
						// Don't auto-convert strings that look like numbers to int
						let type = "string";
						if (val === true || val === false || val === "true" || val === "false") {
							type = "boolean";
						} else if (typeof val === 'number') {
							type = "int";
						}
						// For strings (including numeric-looking strings), default to "string" type
						weightageMap[key] = {
							type: type,
							value: val
						};
					}
				});
			}

			const ttlMaps = {};
			if (value.create_cluster_ttl_maps && typeof value.create_cluster_ttl_maps === 'object') {
				Object.keys(value.create_cluster_ttl_maps).forEach(key => {
					const val = value.create_cluster_ttl_maps[key];
					// Convert old format (just value) to new format (object with type and value)
					if (val && typeof val === 'object' && val.value !== undefined) {
						ttlMaps[key] = { ...val };
					} else {
						// Auto-detect type - only detect int if value is actually a number type
						// Don't auto-convert strings that look like numbers to int
						let type = "string";
						if (val === true || val === false || val === "true" || val === "false") {
							type = "boolean";
						} else if (typeof val === 'number') {
							type = "int";
						}
						// For strings (including numeric-looking strings), default to "string" type
						ttlMaps[key] = {
							type: type,
							value: val
						};
					}
				});
			}

			this.config = {
				graph_ttl: value.graph_ttl || "",
				create_cluster_weightage_map: weightageMap,
				create_cluster_invalid_ids: Array.isArray(value.create_cluster_invalid_ids) ? [...value.create_cluster_invalid_ids] : [],
				create_cluster_ttl_maps: ttlMaps,
				choose_cluster_type: value.choose_cluster_type || "",
				choose_cluster_domain: value.choose_cluster_domain || ""
			};
		},
		resetToDefault(fieldName) {
			this.config[fieldName] = JSON.parse(JSON.stringify(this.fieldInfo[fieldName].defaultValue));
			this.updateConfig();
		},
		getMapValue(fieldName, key) {
			const valueObj = this.config[fieldName][key];
			if (!valueObj || typeof valueObj !== 'object') {
				// Handle old format (just value)
				return valueObj || "";
			}
			return valueObj.value !== undefined ? valueObj.value : "";
		},
		getMapValueType(fieldName, key) {
			const valueObj = this.config[fieldName][key];
			// If valueObj exists and has a type property, always use that type (respect user's choice)
			if (valueObj && typeof valueObj === 'object' && valueObj.type !== undefined && valueObj.type !== null) {
				return valueObj.type;
			}
			// Auto-detect type only for old format data (when type is not set)
			if (!valueObj || typeof valueObj !== 'object') {
				const val = valueObj;
				if (val === true || val === false || val === "true" || val === "false") {
					return "boolean";
				}
				if (typeof val === 'number') {
					return "int";
				}
				// For string values that look like numbers, default to string (don't auto-convert)
				return "string";
			}
			// If it's an object but no type, check the value
			const val = valueObj.value !== undefined ? valueObj.value : valueObj;
			if (val === true || val === false || val === "true" || val === "false") {
				return "boolean";
			}
			if (typeof val === 'number') {
				return "int";
			}
			// Default to string for everything else
			return "string";
		},
		addMapEntry(fieldName) {
			if (!this.config[fieldName]) {
				this.config[fieldName] = {};
			}
			if (this.config[fieldName][""]) {
				return;
			}
			this.config[fieldName][""] = {
				type: "string",
				value: ""
			};
		},
		updateMapKey(fieldName, oldKey, newKey) {
			if (oldKey === newKey) return;
			const valueObj = this.config[fieldName][oldKey];
			delete this.config[fieldName][oldKey];
			this.config[fieldName][newKey] = valueObj;
		},
		updateMapValueType(fieldName, key, type) {
			const currentValueObj = this.config[fieldName][key];
			let currentValue = "";

			if (currentValueObj && typeof currentValueObj === 'object' && currentValueObj.value !== undefined) {
				currentValue = currentValueObj.value;
			} else {
				currentValue = currentValueObj || "";
			}

			// Convert value based on new type
			let convertedValue = currentValue;
			if (type === "boolean") {
				convertedValue = currentValue === true || currentValue === "true" || currentValue === 1;
			} else if (type === "int") {
				if (currentValue === "" || currentValue === null || currentValue === undefined) {
					convertedValue = 0;
				} else {
					convertedValue = String(currentValue).includes('.') ? parseFloat(currentValue) : parseInt(currentValue, 10);
					if (isNaN(convertedValue)) convertedValue = 0;
				}
			} else {
				convertedValue = String(currentValue);
			}

			this.config[fieldName][key] = {
				type: type,
				value: convertedValue
			};
		},
		updateMapValue(fieldName, key, value) {
			const currentType = this.getMapValueType(fieldName, key);
			let convertedValue = value;

			if (currentType === "boolean") {
				convertedValue = value === true || value === "true" || value === 1;
			} else if (currentType === "int") {
				if (value === "" || value === null || value === undefined) {
					convertedValue = 0;
				} else {
					convertedValue = String(value).includes('.') ? parseFloat(value) : parseInt(value, 10);
					if (isNaN(convertedValue)) convertedValue = 0;
				}
			} else {
				convertedValue = String(value);
			}

			this.config[fieldName][key] = {
				type: currentType,
				value: convertedValue
			};
		},
		removeMapEntry(fieldName, key) {
			delete this.config[fieldName][key];
		},
		addArrayItem(fieldName) {
			if (!Array.isArray(this.config[fieldName])) {
				this.config[fieldName] = [];
			}
			this.config[fieldName].push("");
		},
		removeArrayItem(fieldName, index) {
			this.config[fieldName].splice(index, 1);
		},
	},
	emits: ["update:modelValue"],
};
</script>

<style scoped>
.config-row {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
	gap: 1rem;
	margin-bottom: 1rem;
}

.config-row:first-child .config-field {
	flex: 1 1 calc(33.333% - 0.67rem);
	min-width: 200px;
}

.config-row:nth-child(2) .config-field {
	flex: 1 1 calc(50% - 0.5rem);
	min-width: 300px;
}

.config-field {
	padding: 0.7rem;
	background-color: #fafafa;
	border-radius: 4px;
	box-sizing: border-box;
	box-shadow: 4px 4px 4px rgb(234, 234, 234);
}

.config-field-full {
	flex: 1 1 100%;
}

@media (max-width: 992px) {
	.config-row:first-child .config-field {
		flex: 1 1 calc(50% - 0.5rem);
	}
}

@media (max-width: 768px) {

	.config-row:first-child .config-field,
	.config-row:nth-child(2) .config-field {
		flex: 1 1 100%;
	}
}

.input-group {
	display: flex;
	align-items: stretch;
}

.input-group .form-control {
	flex: 1;
}

.form-label {
	font-size: 0.75rem;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

.form-select {
	max-width: 100px;
	background-color: #f6f6f6;
}

.card {
	margin-bottom: 0rem;
}
</style>
